module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDE3IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjAuNjE5NjI5IiB5PSIwLjEzMzMwMSIgd2lkdGg9IjE1LjYiIGhlaWdodD0iMS43MzMzMyIgcng9IjAuODY2NjY3IiBmaWxsPSIjOTk5OTk5Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/minimize-grey.svg
// module id = WWoV
// module chunks = 38